import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";

import TextInput from "../../../ui/TextInput";
import TableItem from "../../../ui/TableItem";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { TIME_CRASHES_DISCOUNT_RATE_FIELDS } from "./operationsAndMaintenanceHelper";
import TooltipIcon from "../../../ui/TooltipIcon";
import Dollar from "../../../ui/Dollar";

export default function ValueOfTimeAndCrashesForm({
  defaultValues,
  errors,
  formData,
  register,
}) {
  return (
    <TableContainer component={Paper} sx={{ marginTop: "30px" }}>
      <Table sx={{ minWidth: 650 }} aria-label="value of time/crashes table">
        <TableHead>
          <TableRow>
            {[
              "Type",
              "Category",
              "Unit Valuation",
              "Default Value",
              "Override Value",
              "Use Value",
              "Notes",
            ].map((title) => (
              <TableItem key={title} header size="small">
                {title}
              </TableItem>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {TIME_CRASHES_DISCOUNT_RATE_FIELDS.map(
            ({
              category,
              fieldName,
              globalDefaultValue,
              notesFieldName,
              storageKey,
              tooltipText,
              type,
              unit,
            }) => {
              const isDollarAmount = unit.includes("$");
              const startAdornment = isDollarAmount ? "$" : undefined;
              const getName = (name) =>
                storageKey ? `${storageKey}.${name}` : name;
              const useValue =
                get(formData, getName(fieldName)) ?? globalDefaultValue;
              return (
                <TableRow key={fieldName}>
                  <TableItem size="small">{type}</TableItem>
                  <TableItem size="small">{category}</TableItem>
                  <TableItem size="small">{unit}</TableItem>
                  <TableItem size="small">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {isDollarAmount ? (
                        <Dollar>{globalDefaultValue}</Dollar>
                      ) : (
                        globalDefaultValue
                      )}
                      {!!tooltipText && <TooltipIcon title={tooltipText} />}
                    </div>
                  </TableItem>
                  <TableItem size="small">
                    <TextInput
                      data-testid={getName(fieldName)}
                      defaultValue={get(defaultValues, getName(fieldName))}
                      errors={errors}
                      min={0}
                      name={getName(fieldName)}
                      register={register}
                      size="small"
                      startAdornment={startAdornment}
                      sx={{ maxWidth: "170px" }}
                      type="number"
                    />
                  </TableItem>
                  <TableItem
                    data-testid={getName(fieldName) + "-useValue"}
                    size="small"
                  >
                    {isDollarAmount ? <Dollar>{useValue}</Dollar> : useValue}
                  </TableItem>
                  <TableItem size="small">
                    <TextInput
                      data-testid={getName(notesFieldName)}
                      defaultValue={get(defaultValues, getName(notesFieldName))}
                      errors={errors}
                      rows={2}
                      multiline
                      name={getName(notesFieldName)}
                      register={register}
                      size="small"
                    />
                  </TableItem>
                </TableRow>
              );
            }
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ValueOfTimeAndCrashesForm.propTypes = {
  defaultValues: PropTypes.object,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object,
  register: PropTypes.func.isRequired,
};
